<template>
  <div class="calico-banner">
    <div :class="['container', variant]">
      <i :class="`bi ${icon[variant]}`" />
      <div class="content body--medium">
        <slot />
      </div>
      <i
        v-if="!fixed"
        :class="`bi bi-x`"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CalicoCard",
  props: {
    variant: {
      type: String,
      default: "info",
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: ""
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      icon: {
        success: 'bi-hand-thumbs-up',
        error: 'bi-exclamation-circle',
        info: 'bi-info-circle'
      }
    }
  }
};
</script>

<style lang="scss">
.calico-banner {
  width: 100%;
  .container {
    @include inline-space($space-medium);
    @include inset-space($space-medium);

    .bi {
      font-size: $icon-medium;
    }

    .content {
      @include stack-space($space-medium);
      flex: 1;
    }

    .bi-x {
      font-size: $icon-medium;
    }

    p {
      margin: 0;
    }
  }

  .info {
    border-radius: $radius-medium;
    border: $border-width-default solid $color-lapis;
    background: $color-lapis-lightest;
  }

  .success {
    border-radius: $radius-medium;
    border: $border-width-default solid $color-border-success;
    background: $color-background-success;
  }

  .error {
    border-radius: $radius-medium;
    border: $border-width-default solid $color-border-error;
    background: $color-background-error;
  }
}
</style>